import React, { PureComponent, Fragment } from 'react'
import LandingPage from './components/LandingPage'
import { connect, compose } from '@hocs'
import { CreatorHead } from '@components/Head/index'
import { withRNApp } from '@libs/RNApp'

class LandingPageContainer extends PureComponent {
  static async getInitialProps({ query }) {
    return {
      isApp: !!query.is_app,
    }
  }
  render() {
    const { isApp } = this.props
    return (
      <Fragment>
        <CreatorHead />
        <LandingPage isApp={isApp} />
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  const { app, currentUser, creator } = state
  return {
    app,
    currentUser,
    postList: creator.get('postList'),
  }
}

export default compose(withRNApp, connect(mapStateToProps))(LandingPageContainer)
